import { createFileRoute } from "@tanstack/react-router";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import AdminRedirects from "@/pages/admin/AdminRedirects";

export const Route = createFileRoute("/admin/redirects")({
  head: () => ({ meta: [{ title: "Redirects | Admin" }, { name: "robots", content: "noindex" }] }),
  component: () => (
    <ProtectedRoute>
      <AdminRedirects />
    </ProtectedRoute>
  ),
});
